import React from "react";
import { FormControl } from "@mui/material";
import {
    FormLabel,
    FormSelect,
    PropertySearch,
    EntitySelect,
    messageTypeOptions,
    updateTypeOptions,
    getEntityLabel,
} from "./FormComponents";

// Common API Form component to reduce duplication
export const ApiForm = ({
    formType,
    config,
    handleInputChange,
    handlePropertySelect,
    handlePropertySearch,
    loading,
    propertyOptions,
    entityLoading,
    entityOptions,
    messageTypeOptions: customMessageTypeOptions,
}) => {
    const isPush = formType === "push";

    const typeOptions = [
        "Rateplan",
        "Roomtype",
        "Cancellation Policy",
    ].includes(config.messageType)
        ? updateTypeOptions.filter(
              (types) => !["enable", "disable"].includes(types.value),
          )
        : updateTypeOptions;

    return (
        <div className="form-row">
            {/* Message Type Selection */}
            <FormControl fullWidth sx={{ marginBottom: 2 }}>
                <FormLabel>Message Type</FormLabel>
                <FormSelect
                    value={config.messageType}
                    onChange={(event) => {
                        handleInputChange(
                            "messageType",
                            event.target.value,
                            formType,
                        );
                    }}
                    placeholder="Select message type"
                    options={customMessageTypeOptions || messageTypeOptions}
                />
            </FormControl>

            {/* Update Type Selection (Push API only) */}
            {isPush && (
                <FormControl fullWidth sx={{ marginBottom: 2 }}>
                    <FormLabel>Update Type</FormLabel>
                    <FormSelect
                        value={config.updateType}
                        onChange={(event) => {
                            handleInputChange(
                                "updateType",
                                event.target.value,
                                formType,
                            );
                        }}
                        placeholder="Select update type"
                        options={typeOptions}
                    />
                </FormControl>
            )}

            {/* Property Search */}
            <FormControl fullWidth sx={{ marginBottom: 2 }}>
                <FormLabel>Property</FormLabel>
                <PropertySearch
                    value={config.property}
                    onChange={(event, value) => {
                        handlePropertySelect(event, value, formType);
                    }}
                    onInputChange={(event, value, reason) => {
                        handlePropertySearch(event, value, reason, formType);
                    }}
                    loading={loading}
                    options={propertyOptions}
                />
            </FormControl>

            {/* Entity Selection (conditional) */}
            {[
                "Rateplan",
                "Roomtype",
                "Taxes",
                "Cancellation Policy",
                "Products",
                "Offer",
            ].includes(config.messageType) && (
                <FormControl fullWidth sx={{ marginBottom: 2 }}>
                    <FormLabel>{getEntityLabel(config.messageType)}</FormLabel>
                    <EntitySelect
                        value={config.entity}
                        onChange={(event) => {
                            handleInputChange(
                                "entity",
                                event.target.value,
                                formType,
                            );
                        }}
                        entityLabel={getEntityLabel(config.messageType)}
                        loading={entityLoading}
                        options={entityOptions}
                    />
                </FormControl>
            )}
        </div>
    );
};

// Specific form components for easier readability
export const PushApiForm = (props) => <ApiForm formType="push" {...props} />;

export const AuditApiForm = (props) => <ApiForm formType="audit" {...props} />;
